<template>
  <div class="container mx-auto my-2">
    <div class="row" v-if="showFamilies">
      <div class="card col-sm-3 text-bg-light mx-auto my-2" style="width: 18rem" v-for="form in formsFamily"
        :key="form.id" @click.prevent="showImages(form.id, form.name)">
        <img :src="serverUrl + 'images/forms/' +
          form.referenceImage" class="rounded card-img-top img-fluid mt-2 mb-2" style="width: 100%; height:100%"
          :alt="form.familyName" />
        <div class="card-body">
          <h5 class="card-title">Grupo {{ form.id }}</h5>
          <h4 class="card-text">
            {{ form.name }}
          </h4>
        </div>
      </div>
      <div class="card col-sm-3 text-bg-light mx-auto my-2" style="width: 18rem" v-show="showNoneImgBtn"
        @click.prevent="showQuoteNoImgForm()">
        <div>
          <img src="../../assets/figuras1.png" style="width: 100%; height:100%"
            class="ounded card-img-top img-fluid mt-2 mb-2" alt="">
        </div>
        <div class="card-body">
          <h3 class="card-title">Formas sin imágen</h3>
          <p class="card-text">Debe calcular el desarrollo de la forma por cuenta propia.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      showFamilies: true,
      formsFamily: [],
      familyName: "",
      serverUrl: RUTA_SERVIDOR,
      showNoneImgBtn: false,
    };
  },
  methods: {
    showImages(id, name) {
      const data = [id, name];
      this.$emit("sendFamilyInfo", data);
      this.showFamilies = false;
    },
    showQuoteNoImgForm() {
      this.$router.push("/SheetNoImgQuote")
    },
  },
  beforeMount() {
    this.familyName = this.$store.getters.getRawMatFamily;
    // console.log(this.familyName);
    axios
      .get(RUTA_SERVIDOR + "api/imgFormFamily/list/material", {
        params: {
          imgFormFamily_rawMaterial: this.familyName,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      // .then((res)=>console.log(res.data))
      .then((res) => (this.formsFamily = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));

    if (this.familyName === "ACERO_CARBONO" || this.familyName === "INOXIDABLE" || this.familyName === "ALUMINIO" || this.familyName === "ANTIDESGASTE") {
      this.showNoneImgBtn = true;
      // this.showNoneImgBtn = false;
    } else {
      this.showNoneImgBtn = false;
    }
  },
};
</script>
<style scoped>
.card-img-top {
  max-height: 230px;
}

.noLink {
  color: black;
  text-decoration: none;
}
</style>